import { alpha } from '@mui/material'
import { fontFallbacks } from '../assets/fonts'
import { colors } from './colors.theme'

const { primary, gray } = colors

export const cssbaseline = {
  fallbacks: fontFallbacks,
  '*': {
    boxSizing: 'border-box',
  },
  /* WebKit Scrollbar */
  '*::-webkit-scrollbar': {
    WebkitAppearance: 'none',
  },
  '*::-webkit-scrollbar:vertical': {
    width: 4,
  },
  '*::-webkit-scrollbar:horizontal': {
    height: 4,
  },
  '*::-webkit-scrollbar-thumb': {
    background: primary,
    borderRadius: 16,
    opacity: '1',
  },
  '*::-webkit-scrollbar-track': {
    background: gray,
    borderRadius: 16,
    opacity: '0.3',
  },
  '@-moz-document url-prefix()': {
    '*': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${primary} transparent`,
    },
  },
  // TODO: these styleOverrides do not work
  '.MuiPickersCalendarHeader-label': {
    color: colors.primary,
    fontWeight: 700,
  },
  '.MuiPickersDay-root': {
    color: `${colors.white}!important`,
    '&.Mui-selected': {
      backgroundColor: colors.primary,
    },
    '&.Mui-disabled': {
      color: `${alpha(colors.white, 0.5)} !important`,
    },
  },

  '.PrivatePickersMonth-root.Mui-selected, .PrivatePickersYear-yearButton.Mui-selected':
    {
      color: colors.primary,
      fontWeight: 700,
    },
  '.MuiDayPicker-weekDayLabel, .MuiPickersArrowSwitcher-button': {
    color: `${colors.white}!important`,
  },
  '.MuiDateCalendar-custom': {
    '& .MuiPickersLayout-actionBar': {
      '& button': {
        color: colors.white,
        '&:hover': { backgroundColor: colors.primary },
      },
    },
  },
  '.customLink': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: colors.white,
    textDecoration: 'none',
    gap: 20,
    '& svg': {
      width: '0.7em',
    },
  },
}
